import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { formatMoney } from '../../helpers/currency';
import { Box, Button, CircularProgress, Typography } from '@material-ui/core';
import * as PropTypes from 'prop-types';


const CardIssuanceConfirmDialog = ({ customerInfo, userInfo, issueCardInfo, open, loading, onConfirm, onClose }) => { 
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          By clicking Yes, you will be issuing cards as per the below summary:
        </DialogContentText>
        <div>
          <div>
            <strong>Customer:</strong> {customerInfo?.customer?.at(0)?.customer_name} ({customerInfo?.customer?.at(0)?.customer_id})
          </div>
          <div>
            <strong>TCNCP user:</strong> {userInfo?.email}
          </div>
          <div>
            <strong>Campaign ID:</strong> {issueCardInfo?.campaign}
          </div>
          <div>
            <strong>Campaign name:</strong> {issueCardInfo?.campaignName}
          </div>
          <div>
            <strong>Order reference:</strong> {issueCardInfo?.orderReference}
          </div>
          {issueCardInfo?.availableBalance && <div><strong>Available balance:</strong> {issueCardInfo?.availableBalance}</div>}
          {(issueCardInfo?.product || issueCardInfo?.productName || issueCardInfo?.variantGuid) && <div>
            <strong>Card type:</strong> {`${issueCardInfo?.product}${issueCardInfo?.productName ? ` - ${issueCardInfo?.productName}` : ""}${issueCardInfo?.variantGuid ? ` (${issueCardInfo?.variantGuid})` : ""}`}
          </div>}
          {issueCardInfo?.units && <div>
            <strong>Units:</strong> {issueCardInfo?.units}
          </div>}
          {issueCardInfo?.denomination && <div>
            <strong>Denomination:</strong> {issueCardInfo?.denomination}
          </div>}
          {issueCardInfo?.countOfCards && <div>
            <strong>Count of cards to be issued:</strong> {issueCardInfo?.countOfCards}
          </div>}
          <div>
            <strong>Value of cards to be issued:</strong> {formatMoney(issueCardInfo?.totalValue)}
          </div>
        </div>
        {!loading && <DialogContentText id="alert-dialog-description">
          Are you sure you want to continue?
        </DialogContentText>}
      </DialogContent>
      <DialogActions>
        {!loading && <Box>
          <Button className="dialog-action-btn" onClick={onConfirm} color="primary">Yes</Button>
          <Button className="dialog-action-btn" onClick={onClose} color="primary" autoFocus>No</Button>
        </Box>}
        {loading && <Box textAlign="center" >
          <Typography style={{ margin: 30 }}>Please wait while we process your request ...</Typography>
          <CircularProgress />
        </Box>}
      </DialogActions>
    </Dialog>
  );
}

CardIssuanceConfirmDialog.propTypes = {
  customerInfo: PropTypes.object,
  userInfo: PropTypes.object,
  issueCardInfo: PropTypes.object,
  open: PropTypes.bool,
  loading: PropTypes.bool,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func
};

export default CardIssuanceConfirmDialog;